import { render } from "./MultiPick.vue?vue&type=template&id=1d80e768&scoped=true"
import script from "./MultiPick.vue?vue&type=script&lang=js"
export * from "./MultiPick.vue?vue&type=script&lang=js"

import "./MultiPick.vue?vue&type=style&index=0&id=1d80e768&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d80e768"]])

export default __exports__